module.exports = __webpack_public_path__ + "media/images/company_bg-31ab82d2500a0b710b4fe15646275a72.jpg";